export const PUBLIC_TRANSPORTATION = "Metro/Tog/Bus"
export const DRIVEN_BY_ANOTHER = "Driven by another"
export const PARKING = "Private car (or motorcycle, scooter)"
